import { render, staticRenderFns } from "./SupplierParameters.vue?vue&type=template&id=57ec78a5&scoped=true&"
import script from "./SupplierParameters.vue?vue&type=script&lang=js&"
export * from "./SupplierParameters.vue?vue&type=script&lang=js&"
import style0 from "./SupplierParameters.vue?vue&type=style&index=0&id=57ec78a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ec78a5",
  null
  
)

export default component.exports